import {Injectable} from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Constant } from 'src/app/common/constant';

@Injectable({ providedIn: 'root' })
export class InvestorService {

  constructor(
    private http: HttpClient,
  ){}

  getProductById(id) {
    return this.http.get(environment.urlBackEnd + Constant.api_common_products_id + id);
  }
}
